import React, { useState, useEffect } from 'react';

const KEY = 'jsdb_lead_shown';

export default function LeadCapture() {
  const [visible, setVisible] = useState(false);
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle | success | error

  useEffect(() => {
    if (sessionStorage.getItem(KEY)) return;
    // Show after 35s or when user scrolls 60%
    const timer = setTimeout(() => show(), 35000);
    const onScroll = () => {
      const pct = window.scrollY / (document.documentElement.scrollHeight - window.innerHeight);
      if (pct > 0.6) show();
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => { clearTimeout(timer); window.removeEventListener('scroll', onScroll); };
  }, []);

  const show = () => {
    if (!sessionStorage.getItem(KEY)) setVisible(true);
  };

  const dismiss = () => {
    sessionStorage.setItem(KEY, '1');
    setVisible(false);
  };

  const submit = (e) => {
    e.preventDefault();
    if (!email.trim() || !/\S+@\S+\.\S+/.test(email)) return;
    // In production: call your email API here
    console.log('Lead captured:', email);
    setStatus('success');
    setTimeout(dismiss, 3000);
    sessionStorage.setItem(KEY, '1');
  };

  if (!visible) return null;

  return (
    <div className="lead-overlay" role="dialog" aria-label="Get free consultation" onClick={(e) => e.target === e.currentTarget && dismiss()}>
      <div className="lead-modal">
        <button className="lead-close" onClick={dismiss} aria-label="Close">✕</button>
        <div className="lead-badge">🎁 Free Offer</div>
        <h3 className="lead-title">Get a Free Tech Consultation</h3>
        <p className="lead-desc">
          Share your email and we'll send you a <strong>free 30-minute cloud/AI strategy session</strong> — no strings attached.
        </p>
        {status === 'success' ? (
          <div className="lead-success">
            ✅ <strong>Done!</strong> Check your inbox — we'll reach out within 24 hours.
          </div>
        ) : (
          <form className="lead-form" onSubmit={submit}>
            <input
              type="email"
              className="lead-input"
              placeholder="your@email.com"
              value={email}
              onChange={e => setEmail(e.target.value)}
              autoFocus
              required
              aria-label="Your email address"
            />
            <button type="submit" className="lead-btn">Claim Free Session →</button>
          </form>
        )}
        <p className="lead-note">🔒 No spam, ever. Unsubscribe anytime.</p>
        <div className="lead-trust">
          <span>⭐ 50+ Projects</span>
          <span>🌍 5 Countries</span>
          <span>✅ 100% Satisfaction</span>
        </div>
      </div>
    </div>
  );
}
